import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';

class Component extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render () {
		const {
			name,
			type,
			fromVersion,
			toVersion,
			components,
			link,
			releaseName
		} = this.props;

		const showName = type === 'updates';

		const current = this.intl.formatMsg('(currently {fromVersion})', { fromVersion });
		const from = <span className="from-version">{current}</span>;
		const format = {
			action: (type === 'updates')
				? this.intl.formatMsg('Update to')
				: this.intl.formatMsg('Upgrade to'),
			from,
			to: <span className="version to-version">{toVersion}</span>,
			releaseName: releaseName ? `"${releaseName}"` : ''
		};

		const actionText
			= this.intl.formatHTMLMsg('{action} {to} {releaseName} {from}', format);

		return (
			<li className="update-item">
				{showName && (
					<span>
						<b className="name">{name}</b><br />
					</span>
				)}
				{components.map(component => {
					return (
						<div key={component} className="component-package-name">
							{component}
						</div>
					);
				})}
				{actionText}
				<br />
				{link}
			</li>
		);
	}
}

Component.propTypes = {
	/**
	 * The type of component to render.
	 */
	type: PropTypes.oneOf([ 'updates', 'upgrades' ]).isRequired,
	/**
	 * The updates available for the service.
	 */
	name: PropTypes.string.isRequired,
	/**
	 * Indicates the name should be rendered.
	 */
	showName: PropTypes.bool,
	/**
	 * The current version of the updated component.
	 */
	fromVersion: PropTypes.string.isRequired,
	/**
	 * The target version of the component to upgrade to.
	 */
	toVersion: PropTypes.string.isRequired,
	/**
	 * The release name.
	 */
	releaseName: PropTypes.string,
	/**
	 * The array of components.
	 */
	components: PropTypes.arrayOf(PropTypes.string).isRequired,
	/**
	 * An element <a /> that links to the documentation.
	 */
	link: PropTypes.element
};

Component.defaultProps = {
	showName: true
};

export default injectIntl(Component);
